const CleanUrl = (value) => {
    if(value){
        value = value.toLowerCase(); 
        value = value.replace(/ /gi,'-');
    }
    return value;
}

export { CleanUrl }